export default {
  methods: {
    /* validation */
    isEmpty(str) {
      return (!str || str.length === 0 );
    },
    isNumber(value) {
      return typeof value === 'number' && isFinite(value);
    },
    isNumberOrNull(value) {
      return value === null || (typeof value === 'number' && isFinite(value));
    },
    isNumberObject(n) {
      return (Object.prototype.toString.apply(n) === '[object Number]');
    },
    isCustomNumber(n){
      return this.isNumber(n) || this.isNumberObject(n);
    },
    dateValidation(dateStr) {
      if (!dateStr) return false;

      const dateObj = new Date(dateStr);
      return !isNaN(dateObj.getTime()) && dateObj.getTime() !== 0;
    },
    isDateValid(dateStr) {
      return !isNaN(new Date(dateStr));
    },
    phoneString(phone) {
      const number = this.phoneNationalNumber(phone);
      return /^\d{10}$/.test(number) ? '+7' + number : String(phone || '').trim();
    },
    phoneInputPrefix(phone) {
      const value = String(phone || '').trim();
      if (value.startsWith('+')) return null;

      const digits = value.replace(/\D/g, '');
      if (/^[78]\d{10}$/.test(digits)) {
        return digits.startsWith('7') ? '+' : null;
      }

      return '+7';
    },
    phoneNationalNumber(phone) {
      const value = String(phone || '').replace(/[\s()-]/g, '');
      if (value.startsWith('+7')) return value.slice(2);
      if (/^[78]\d{10}$/.test(value)) return value.slice(1);
      return value;
    },
    contactPhoneState(phone) {
      if (!String(phone || '').trim()) return null;
      return /^\d{10}$/.test(this.phoneNationalNumber(phone));
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    },
    /* helpers */
    telUrl(phone) {
      const number = this.phoneString(phone);
      return number ? 'tel:' + number : '';
    },
    priceFormat(value, round = false) {
      const num = Number(value) || 0;
      const val = round ? Math.round(num * 100) / 100 : num;
      return new Intl.NumberFormat('ru-RU').format(val);
    },
    paymentTypeString(flag) {
      switch (flag) {
        case 0: return "Нал"
        case 1: return "ООО"
        case 2: return "ИП"
        case 3: return "СМЗ"
        default: return "Неизвестно"
      }
    },
    paymentTypeIcon(flag) {
      switch (flag) {
        case 0: return {icon:"coins", title: "Нал"}
        case 1: return {icon:"file-invoice-dollar", title: "НДС"}
        case 2: return {icon:"user", title: "бех НДС"}
        case 3: return {icon:"file-invoice-dollar", title: "СМЗ"}
        default: return {icon:"user-slash", title: "Неизвестно"}
      }
    },
    yesOrNoText(flag) {
      return flag ? "Да" : "Нет";
    },
    yesOrNoIcon(flag) {
      return {
        icon: flag ? "check" : "times",
        style: { color: flag ? 'darkgreen' : 'darkred' }
      };
    },
    yesOrNoPayIcon(flag) {
      return {
        icon: "users",
        style: { color: flag ? 'darkgreen' : 'darkred' }
      };
    },
    readOnly(row) {
      const isReadOnly = !!row.item.read_only;
      return {
        icon: "pen",
        style: { color: isReadOnly ? 'gray' : 'darkgreen' }
      };
    },
    getBadgeStyle(hex) {
      if (!hex || !hex.startsWith('#') || hex.length !== 7) {
        return { backgroundColor: '#f8f9fa', color: '#6c757d', border: '1px solid #dee2e6' };
      }

      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      // чем выше ratio, тем пастельнее
      const mix = (color, ratio) => Math.round(color + (255 - color) * ratio);

      const bg = `rgb(${mix(r, 0.7)}, ${mix(g, 0.7)}, ${mix(b, 0.7)})`;
      const border = `rgb(${mix(r, 0.3)}, ${mix(g, 0.3)}, ${mix(b, 0.3)})`;
      const text = `rgb(${Math.round(r * 0.5)}, ${Math.round(g * 0.5)}, ${Math.round(b * 0.5)})`;

      return {
        backgroundColor: bg,
        borderColor: border,
        color: text,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '4px',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: '500',
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap'
      };
    },
    onlyNumbers(e) {
      const serviceKeys = ['Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!serviceKeys.includes(e.key) && !/\d/.test(e.key)) e.preventDefault();
    },
    preventMinus(event) {
      if (event.key === '-') event.preventDefault();
    },
    /* sorting */
    sortCompare(a, b, key) {
      if (key === 'id') {
        if (a.id === 0 && b.id !== 0) { return 1; }
        if (b.id === 0 && a.id !== 0) { return -1; }
        if (a.id === 0 && b.id === 0) { return 0; }
        return a.id - b.id;
      }
      return null;
    },
    sortPeriodCompare(aRow, bRow, key) {
      if (key === 'period') {
        const startDateA = new Date(aRow.start_date).getTime();
        const startDateB = new Date(bRow.start_date).getTime();

        if (startDateA < startDateB) {
          return -1;
        } else if (startDateA > startDateB) {
          return 1;
        } else {
          const endDateA = new Date(aRow.end_date).getTime();
          const endDateB = new Date(bRow.end_date).getTime();

          if (endDateA < endDateB) return -1;
          if (endDateA > endDateB) return 1;

          return 0;
        }
      }
      return null;
    },
    async sortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (typeof this.getItems === 'function') await this.getItems();
    },
    /* vacancy text */
    transliterate(text) {
      const map = {
        а: 'a', б: 'b', в: 'v', г: 'g', д: 'd',
        е: 'e', ё: 'yo', ж: 'zh', з: 'z', и: 'i',
        й: 'j', к: 'k', л: 'l', м: 'm', н: 'n',
        о: 'o', п: 'p', р: 'r', с: 's', т: 't',
        у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch',
        ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '',
        э: 'e', ю: 'yu', я: 'ya'
      };
      return text
        .toLowerCase()
        .split('')
        .map(char => map[char] || char)
        .join('');
    },
    generateVacancyTextString(item) {
      if (!item) return '';

      const textConfig = [
        { key: 'workers_count', label: 'Количество исполнителей' },
        { key: 'duties', label: 'Обязанности'},

        // Требования
        { label: 'Требования', type: 'separator' },
        { key: 'sex', label: 'Пол' },
        { key: 'age_range', label: 'Возраст' },
        { key: 'citizenships', label: 'Гражданство', catalogRef: 'citizenshipsCatalog' },
        { key: 'criminal_record', commentKey: 'criminal_record_comment', label: 'Судимость', type: 'checkbox-input' },
        { key: 'work_exp', label: 'Опыт работы' },
        { key: 'physical_work', commentKey: 'physical_work_comment', label: 'Физический труд', type: 'checkbox-input' },
        { key: 'expectations', label: 'Ожидания от кандидата' },
        { key: 'certificates', arrayMappings: [{ key: 'driver_license_categories', catalogRef: 'driverLicenseCategoriesCatalog' }], label: 'Удостоверения / права', type: 'complex' },
        { key: 'medical_book', commentKey: 'medical_book_comment', label: 'Медкнижка', type: 'checkbox-input' },

        // Условия
        { label: 'Условия', type: 'separator' },
        {
          key: 'employment',
          arrayMappings: [{ key: 'employment_types', optionsRef: 'employmentTypesOptions' }],
          label: 'Оформление',
          type: 'complex'
        },
        { key: 'employment_categories', label: 'Занятость', catalogRef: 'employmentCategoriesCatalog' },
        {
          key: 'schedule',
          arrayMappings: [{ key: 'schedule_time_of_day', optionsRef: 'shiftOptions' }],
          extraKey: 'night_coefficient',
          extraLabel: 'Ночной коэффициент',
          label: 'График',
          type: 'complex'
        },
        {
          key: 'output_format',
          arrayMappings: [{ key: 'output_format', optionsRef: 'outputFormatOptions' }],
          label: 'Формат выхода',
          type: 'complex'
        },
        { key: 'shift_hours', label: 'Часы работы' },
        { key: 'break_hours', label: 'График перерывов' },
        { key: 'work_rate', label: 'Выработка (норма)' },
        { key: 'salary', label: 'Ставка' },
        { key: 'salary_smz', label: 'Ставка СМЗ' },
        { key: 'salary_hand', commentKey: 'salary_hand_comment', label: 'Карта / на руки', type: 'checkbox-input' },
        { key: 'payment_period', label: 'Периодичность выплат' },
        { key: 'probation', label: 'Стажировка' },
        { key: 'compensation', label: 'Компенсации' },
        { key: 'meals', label: 'Питание' },
        { key: 'accommodation', label: 'Проживание' },
        { key: 'brigadier_bonus', label: 'Премия бригадиру' },
        { key: 'uniform', label: 'Униформа' },
        { key: 'wardrobe', label: 'Гардероб' },
        { key: 'indoor_conditions', label: 'Характеристика помещений' },
        { key: 'transport', label: 'Как добраться' },
        { key: 'corp_transport', commentKey: 'corp_transport_comment', label: 'Корпоративный транспорт', type: 'checkbox-input' },
        { key: 'security_service', commentKey: 'security_service_comment', label: 'Служба безопасности', type: 'checkbox-input' },
        { key: 'access_mode', commentKey: 'access_mode_comment', label: 'Пропускной режим', type: 'checkbox-input' },
        { key: 'prohibited', label: 'Ограничения на объекте' },
      ];

      let text = `Вакансия: ${item.vacancy_name}\n`;

      const parseArray = (array, optionsRef, catalogRef) => {
        if (!array || !Array.isArray(array)) return '';

        const options = optionsRef ? this[optionsRef] : null;
        const catalog = catalogRef ? this[catalogRef] : null;

        return array.map(val => {
          if (options) {
            const found = options.find(opt => opt.value === val);
            if (found) return found.text;
          }
          if (catalog) {
            const found = catalog.find(cat => cat.id === val);
            if (found) return found.name;
          }
          return val;
        }).filter(Boolean).join(', ');
      };

      textConfig.forEach(field => {
        if (field.type === 'separator') {
          text += `\n${field.label}:\n`;
          return;
        }

        if (field.key === 'age_range') {
          const { age_from, age_to } = item;
          if (age_from || age_to) {
            const ageParts = [];

            if (age_from) ageParts.push(`от ${age_from}`);

            if (age_to) ageParts.push(`до ${age_to}`);

            text += `- ${field.label}: ${ageParts.join(' ')};\n`;
          }
          return;
        }

        const value = item[field.key];

        if (field.type === 'checkbox-input') {
          const comment = typeof item[field.commentKey] === 'string' ? item[field.commentKey].trim() : '';

          if (value || comment) {
            const boolText = value ? 'Да' : 'Нет';
            text += `- ${field.label}: ${comment ? `${boolText} (${comment})` : boolText};\n`;
          }
          return;
        }

        if (field.type === 'complex') {
          const parts = [];

          if (typeof value === 'string' && value.trim()) {
            parts.push(value.trim());
          }

          if (field.arrayMappings) {
            field.arrayMappings.forEach(mapping => {
              const parsed = parseArray(item[mapping.key], mapping.optionsRef, mapping.catalogRef);
              if (parsed) parts.push(parsed);
            });
          }

          if (field.extraKey && item[field.extraKey]) {
            parts.push(`${field.extraLabel || field.extraKey}: ${String(item[field.extraKey]).trim()}`);
          }

          if (parts.length > 0) {
            text += `- ${field.label}: ${parts.join('; ')};\n`;
          }
          return;
        }

        if (Array.isArray(value)) {
          const parsedPart = parseArray(value, field.optionsRef, field.catalogRef);
          if (parsedPart) {
            text += `- ${field.label}: ${parsedPart};\n`;
          }
          return;
        }

        if (value !== null && value !== undefined && value !== '') {
          text += `- ${field.label}: ${value};\n`;
        }
      });

      return text;
    },
    /* modals */
    showOnboardingModal() {
      const h = this.$createElement;
      const customBody = h('div', { class: 'p-2 text-center' }, [
        h('v-icon', {
          props: { name: 'buttons/info', size: 32 },
          style: { color: '#1A9167' },
          class: 'mb-2'
        }),
        h('div', { style: { fontSize: '14px', color: '#212529' } }, 'При назначении исполнителя на дату создаётся одна заявка, можно создать одну или несколько.')
      ]);

      this.$bvModal.msgBoxOk([customBody], {
        centered: true,
        hideHeader: true,
        noCloseOnBackdrop: true,
        okTitle: 'Далее',
        modalClass: 'custom-common-modal hint-modal'
      }).then(() => {
        setTimeout(() => {
          this.onboardingStep = 2;
        }, 400);
      });
    },
    showGenerateFileError(title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: 'danger',
        autoHideDelay: 3000,
        solid: true
      });
    },
    showSubmitError(message) {
      this.$bvToast.toast(message, {
        title: 'Ошибка сохранения',
        variant: 'danger',
        autoHideDelay: 3000,
        solid: true
      });
    },
    showToast(message, title, variant) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 3000
      });
    },
    showError(message, description) {
      const h = this.$createElement

      const customBody = h('div', { class: 'custom-delete-body' }, [
        h('div', { class: 'custom-delete-header' }, [
          h('v-icon', {
            props: { name: 'buttons/circle_cross', size: 20 },
            style: { color: '#dc3545' }
          }),
          h('span', { class: 'custom-delete-title' }, 'Ошибка')
        ]),
        h('div', { class: 'custom-delete-message' }, message),
        h('div', { class: 'custom-delete-message' }, description)
      ]);

      this.$bvModal.msgBoxOk([customBody], {
        modalClass: 'custom-common-modal',
        centered: true,
        hideHeader: true,
        hideHeaderClose: true,
        buttonSize: 'sm',
        okVariant: 'secondary',
        okTitle: 'Назад',
      });
    },
    showModalDelete(title, message, okAction) {
      const h = this.$createElement;

      const customBody = h('div', { class: 'custom-delete-body' }, [
        h('div', { class: 'custom-delete-header' }, [
          h('v-icon', {
            props: { name: 'buttons/circle_cross', size: 20 },
            style: { color: '#dc3545' }
          }),
          h('span', { class: 'custom-delete-title' }, title)
        ]),
        h('div', { class: 'custom-delete-message' }, message)
      ]);

      this.$bvModal.msgBoxConfirm([customBody], {
        modalClass: 'custom-common-modal',
        centered: true,
        hideHeader: true,
        hideHeaderClose: true,
        buttonSize: 'sm',
        okTitle: `${this.$t('message.actions.remove')}`,
        cancelTitle: 'Отменить',
        okVariant: 'danger',
        cancelVariant: 'secondary',
      }).then(value => {
        if (value && value === true) {
          okAction();
        }
      });
    },
    showSuccess(message, description) {
      const h = this.$createElement
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('p', [ message ]),
        h('p', { class: ['text-small'] }, [ description ])
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: 'Успешно!',
        headerBgVariant: 'success',
        headerTextVariant: 'secondary'
      });
    },
    async showAcceptModal(title, message, variant) {
      return await this.$bvModal.msgBoxConfirm(message, {
        title: title,
        buttonSize: 'sm',
        okTitle: `${this.$t('message.actions.continue')}`,
        cancelTitle: `${this.$t('message.actions.cancel')}`,
        okVariant: variant || 'danger',
        headerBgVariant: variant || 'danger',
        headerTextVariant: 'secondary'
      }).then(value => {
        return value && value === true;
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/utilites/helpers.js